<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="个人资料" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
            <a-row class="form-row" :gutter="16">
              <a-form-item
                label="头像"
                :labelCol="{lg: {span: 3}, sm: {span: 3}}"
                :wrapperCol="{lg: {span: 14}, sm: {span: 14} }">
                <img v-if="!isEdit" :src="headpicUrl" style="width:100px;border:1px solid #ccc;" alt="头像"/>
                <a-upload
                  v-if="isEdit"
                  name="file"
                  :defaultFileList="headpicList"
                  listType="picture-card"
                  class="avatar-uploader"
                  :showUploadList="false"
                  action="/teacher.php/upload_file/uploadFile?type=teacher&local=YES"
                  @change="handleHeadpicChange"
                >
                  <img v-if="headpicUrl" :src="headpicUrl" style="width:100px;" alt="头像" />
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-row>
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="账号"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <span>{{ data.account || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="密码"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input placeholder="留空不修改密码" v-show="isEdit" v-decorator="['password']"/>
                  <span v-if="!isEdit">******</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="英文名"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <!-- <a-input v-show="isEdit" v-decorator="['english_name',{initialValue: data.english_name, rules: [{ required: true, message: '请输入英文名' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.english_name || '--' }}</span> -->
                  <span>{{ data.english_name || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="国籍"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <span>{{ data.nationality || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="性别"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <span v-if="!isEdit">{{ data.sex || '--' }}</span>
                  <a-radio-group 
                    v-show="isEdit"
                    v-decorator="[
                      'sex',
                      {
                        initialValue: data.sex,
                        rules: [{ required: true, message: '请选择性别' }]
                      }
                    ]"
                    placeholder="请选择性别">
                    <a-radio-button value="男">
                      男
                    </a-radio-button>
                    <a-radio-button value="女">
                      女
                    </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="出生日期"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-date-picker v-show="isEdit" :default-value="moment(data.birthtime)"  @change="onBirthtimeChange" placeholder="请选择出生日期"/>
                  <span v-if="!isEdit">{{ data.birthtime || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="入职日期"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <!-- <a-date-picker v-show="isEdit" :default-value="moment(data.entrytime)"  @change="onEntrytimeChange" placeholder="请选择入职日期"/>
                  <span v-if="!isEdit">{{ data.entrytime || '--' }}</span> -->
                  <span>{{ data.entrytime || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="手机号码"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['tel',{initialValue: data.tel, rules: [{ required: true, message: '请输入手机号码' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.tel || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="联系方式"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <!-- <a-input v-show="isEdit" v-decorator="['qq',{initialValue: data.qq, rules: [{ required: true, message: '请输入联系方式' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.qq || '--' }}</span> -->
                  <span>{{ data.qq || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="zoom"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['zoom',{initialValue: data.zoom}]"/>
                  <span v-if="!isEdit">{{ data.zoom || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="Skype"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['skype',{initialValue: data.skype}]"/>
                  <span v-if="!isEdit">{{ data.skype || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="Wechat"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['wechat',{initialValue: data.wechat}]"/>
                  <span v-if="!isEdit">{{ data.wechat || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="其他联系方式"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['other_contact',{initialValue: data.other_contact}]"/>
                  <span v-if="!isEdit">{{ data.other_contact || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="我的录音"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-upload
                    v-show="isEdit"
                    name="file"
                    :multiple="false"
                    list-type="text"
                    action="/admin.php/upload_file/uploadFile?type=teachersound"
                    @change="handleChange"
                  >
                    <a-button><a-icon type="upload" />点击重新上传</a-button>
                  </a-upload>
                  <a :href="soundrecording" target="_blank" v-if="!isEdit">下载录音</a>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="我的标签"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <!-- <a-input v-show="isEdit" placeholder="请输入标签，多个使用英文逗号隔开" v-decorator="['label',{initialValue: data.label}]"/>
                  <span v-if="!isEdit">{{ data.label || '--' }}</span> -->
                  <span>{{ data.label || '--' }}</span>
                </a-form-item>
              </a-col>
              <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 12}" :sm="12">
                <a-form-item
                  label="我的简介"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-textarea
                    v-show="isEdit"
                    v-decorator="[
                      'introduce',
                      {
                        initialValue: data.introduce
                      }
                    ]"
                    :rows="6"
                    placeholder="请输入简介"/>
                    <span v-if="!isEdit">{{ data.introduce || '--' }}</span>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
import { teacherDetail, saveTeacher } from '@/api/account'
import { mixin, mixinDevice } from '@/utils/mixin'
// import { buildFile } from '@/utils/util'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {},
      fileList: [],
      headpicList: [],
      headpicUrl: '/avatar.png',
      soundrecordingUrl: ''
    }
  },
  methods: {
    moment,
    handlePre () {
      teacherDetail().then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          if (this.data.soundrecording !== '') {
            this.soundrecording = this.data.soundrecording
            this.fileList.push(
              {
                uid: '-1',
                name: '已上传录音',
                url: this.data.soundrecording
              }
            )
          }
          if (this.data.headpic !== '') {
            this.headpicUrl = this.data.headpicUrl
            this.headpicList.push(
              {
                uid: '-1',
                name: '已上传头像',
                url: this.data.headpicUrl
              }
            )
          }
          this.form.setFieldsValue(this.data)
        }
      })
    },
    onBirthtimeChange(date, dateString) {
      this.data.birthtime = dateString
    },
    onEntrytimeChange(date, dateString) {
      this.data.entrytime = dateString
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.data[targetId] = path
        if (targetId === 'headpic') {
          this.headpicUrl = fileUrl
        }
        if (targetId === 'soundrecording') {
          this.soundrecordingUrl = fileUrl
        }
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleChange (info) {
      this.handleFileUpload(info, 'soundrecording')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleHeadpicChange (info) {
      this.handleFileUpload(info, 'headpic')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveTeacher(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
